import React, { useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";

import { parseQueryParams } from "../../../libs/Util";
import ActiveLearningLessons from "../../../templates/teacher/ActiveLearningLessons";
import {
  Context,
  fetchActiveLearningThemes,
  fetchActiveLearningAnswers,
  fetchActiveLearningMaterialLessons,
  fetchActiveLearningMaterialAnswers,
  fetchClassesByGrade,
  notFoundPath,
} from "../../../teacherStore";

import styles from "./ActiveLearningLessonPage.module.scss";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const material_code = parseQueryParams()["code"];
  const class_ids = parseQueryParams()["classList"];
  const history = useHistory();
  const { no } = useParams();

  if (
    state.available_item_codes.length === 0 ||
    !state.available_item_codes.includes(material_code)
  ) {
    history.push(notFoundPath);
    return null;
  }

  useEffect(() => {
    dispatch(fetchActiveLearningThemes());
    dispatch(fetchClassesByGrade());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchActiveLearningAnswers(class_ids));
  }, [dispatch, class_ids]);

  useEffect(() => {
    dispatch(fetchActiveLearningMaterialLessons(material_code, no));
  }, [dispatch, material_code, no]);

  useEffect(() => {
    dispatch(fetchActiveLearningMaterialAnswers(material_code));
  }, [dispatch, material_code]);

  return (
    <div className={styles.wrapper}>
      <ActiveLearningLessons
        materialCode={material_code}
        lessonNo={Number(no)}
      />
    </div>
  );
};
